export default {
  en: {
    closed: 'implement closed label',
    clear_votes: 'Clear my votes',
    total: {
      zero: 'implement zero count label %{count}',
      one: 'implement one count label %{count}',
      other: 'implement many count label %{count}',
    },
    snack: {
      generic_error_msg: 'Something went wrong!',
    },
  },
};
